module.exports = __webpack_public_path__ + "img/gold-coins-icon.fd0b79bf.svg";